import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Stack,
  IconButton
} from '@mui/material';
import {
  ArrowBack
} from '@mui/icons-material';
import OperationDetails from '../../components/OperationDetails';
import { useNavigate, useParams } from 'react-router-dom';

const OperationDetailsPage: React.FC = () => {
  const navigate = useNavigate();
  const { operationId } = useParams<{ operationId: string }>();

  const handleBack = () => {
    navigate(-1); // Go back to previous page
  };

  if (!operationId) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">
          Operation ID not provided
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Paper sx={{ borderRadius: 0, borderBottom: 1, borderColor: 'divider', p: 2 }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <IconButton onClick={handleBack}>
            <ArrowBack />
          </IconButton>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
              Operation Details
            </Typography>
            <Typography variant="body2" color="text.secondary">
              View transfers and information for this operation
            </Typography>
          </Box>
        </Stack>
      </Paper>

      {/* Content */}
      <Box sx={{ flex: 1, overflow: 'auto', p: 3 }}>
        <OperationDetails
          operationId={operationId}
          onBack={handleBack}
        />
      </Box>
    </Box>
  );
};

export default OperationDetailsPage;